export const getSignalParams = (controller) => {
  if (controller?.current) {
    return {
      signal: controller.current.signal,
    };
  }
  return {};
};
